"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContrastColor = getContrastColor;
exports.isContrastColorNeeded = isContrastColorNeeded;
function getContrastColor(bgColor, fallbackColor = 'white') {
  if (!bgColor) return fallbackColor;
  // Remove the # if present and parse the hexadecimal color
  const hex = bgColor.replace('#', '');
  const r = parseInt(hex?.substring(0, 2), 16);
  const g = parseInt(hex?.substring(2, 4), 16);
  const b = parseInt(hex?.substring(4, 6), 16);

  // Calculate the relative luminance
  const luminance = 0.2126 * (r / 255) ** 2.2 + 0.7152 * (g / 255) ** 2.2 + 0.0722 * (b / 255) ** 2.2;

  // Choose white or black based on luminance
  return luminance > 0.179 ? 'black' : 'white';
}
function isContrastColorNeeded(bgColor) {
  return getContrastColor(bgColor) !== 'white';
}